<template>
    <div class="search-trends bg-white mt-8">
        <div class="search-trends__header h-24 flex items-center justify-between px-8 text-primary-color">
            <div class="search-trends__header--title text-3xl text-gray-600">สินค้า</div>
            <button class="search-trends__header--btn text-2xl">
                <i class="far fa-sync"></i>
                ดูเพิ่มเติม
            </button>
        </div>

        <div class="search-trends__contains">
            <ul class="search-trends__contains__list w-full flex flex-wrap">
                <li v-for="(item, index) in data" :key="index" class="search-trends__contains__item">
                    <a href="/" class="search-trends__contains--link h-full w-full flex items-center">
                        <div class="search-trends__contains__content flex-13 text-center">
                            <div class="search-trends__contains__content__name text-2xl">{{ item.name }}</div>
                            <div class="search-trends__contains__content__quantity text-xl text-gray-400">{{ item.quantity }}</div>
                        </div>
                        <div :style="url(item.url)" class="search-trends__contains__img flex-10"></div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchTrends',
    setup(){
        const data = [
            {
                name: 'เกมพกพา',
                quantity: '9k+ ชิ้น',
                url: 'https://down-th.img.susercontent.com/file/sg-11134201-23030-l6gfmonyswov5a'
            },
            {
                name: 'เสื้อ',
                quantity: '659k+ ชิ้น',
                url: 'https://down-th.img.susercontent.com/file/ddbfb462b3e76dfa1d1ffbd2297cc5d4'
            },
            {
                name: 'กระเป๋า',
                quantity: '3k+ ชิ้น',
                url: 'https://down-th.img.susercontent.com/file/3eb8e312cc7a323379d5395b13b4199a'
            },
            {
                name: 'ตุ๊กตา',
                quantity: '39k+ ชิ้น',
                url: 'https://down-th.img.susercontent.com/file/sg-11134201-22120-17postqbmvkvae'
            }
        ]

        return{
            data
        }
    },
    methods: {
        url: function(url){
            return `background-image: url(${url});`
        }
    }
}
</script>

<style scoped>
.search-trends__header{
    border-bottom: 1px solid #ddd;
}

.search-trends__contains__item{
    width: 25%;
    height: 10rem;
    border: 1px solid #ddd;
}

.search-trends__contains__img{
    width: 90%;
    height: 100%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

/* mobile & tablet */
@media (max-width: 1023px){
    .search-trends__contains__item{
        width: 50%;
    }
}
</style>